import * as React from "react";
const GMap = require('google-map-react');
const GoogleMapReact = GMap.default;
import Marker from "../map-marker";
export default class MapView extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let store = this.props.selectedEvent;
        let marker = store ? React.createElement(Marker, { lat: store.Latitude ? store.Latitude : 0, lng: store.Longitude ? store.Longitude : 0 }) : null;
        return (React.createElement("div", { className: "map-view" },
            React.createElement(GoogleMapReact, { ref: "googleMap", center: this.props.selectedEvent ? { lat: this.props.selectedEvent.Latitude, lng: this.props.selectedEvent.Longitude } : { lat: 53.542741, lng: -113.4912073 }, zoom: 18, yesIWantToUseGoogleMapApiInternals: true, bootstrapURLKeys: {
                    key: window.document.mapAPIKey
                } }, marker)));
    }
}
;
//# sourceMappingURL=map-view.js.map